module.exports = __webpack_public_path__ + "static/media/icon-dropdown.981b1f5d.svg";